import moment from 'moment'
export const convertDateAndTimeToDateTime = (date, time) => {
  const dateStr = moment(date).format(moment.HTML5_FMT.DATE)
  const timeStr = moment(time).format(moment.HTML5_FMT.TIME_MS)
  const dateTime = moment(
    dateStr + timeStr,
    moment.HTML5_FMT.DATE + moment.HTML5_FMT.TIME_MS,
  )
  return dateTime
}



// WEBPACK FOOTER //
// ./src/services/converter.js